import { createReducer } from 'utils';
import { createSelector } from 'reselect';
import {
  UPDATE_STREAM_URLS,
  STREAM_URLS_REQUEST_ERROR,
  UPDATE_ACTIVE_VIDEO_HANDLER,
} from 'constants/actions';

const initialState = {
  backoffSettings: {
    maxAttempts: 100,
    initialDelay: 2500,
    delta: 1.35,
    maxDelay: 60 * 1000,
  },
  activeVideoHandler: null,
  urls: [],
  error: null,
};

export default createReducer(initialState, {
  [UPDATE_STREAM_URLS]: (state, payload) => ({
    ...state,
    urls: payload,
    error: null,
  }),
  [STREAM_URLS_REQUEST_ERROR]: (state, payload) => ({
    ...state,
    error: payload,
  }),
  [UPDATE_ACTIVE_VIDEO_HANDLER]: (state, payload) => ({
    ...state,
    activeVideoHandler: payload,
  }),
});

export const getStreamUrls = createSelector(
  state => state.urls,
  urls => urls,
);

export const getStreamRequestSettings = createSelector(
  state => state.backoffSettings,
  backoffSettings => backoffSettings,
);

export const getStreamRequestError = createSelector(
  state => state.error,
  error => error,
);

export const getIsStreamAvailable = createSelector(
  getStreamUrls,
  state => state.activeVideoHandler,
  (urls, activeVideoHandler) => {
    if (!urls || !urls.length || typeof activeVideoHandler !== 'string') {
      return false;
    }

    return true;
  },
);
